import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PipelineRegistryPage from "./pages/PipelineRegistryPage";
import PipelineDetailsPage from "./pages/PipelineDetailsPage";
import IncidentCenterPage from "./pages/IncidentCenterPage";
import LineageExplorerPage from "./pages/LineageExplorerPage";
import AuditLogPage from "./pages/AuditLogPage";
import IncidentReportPage from "./pages/IncidentReportPage";
import MonitorsPage from "./pages/MonitorsPage";
import SLOsPage from "./pages/SLOsPage";
import HostMapPage from "./pages/HostMapPage";
import EventsExplorerPage from "./pages/EventsExplorerPage";
import MetricsExplorerPage from "./pages/MetricsExplorerPage";
import LogsExplorerPage from "./pages/LogsExplorerPage";
import TracesExplorerPage from "./pages/TracesExplorerPage";
import DashboardsPage from "./pages/DashboardsPage";
import NotebooksPage from "./pages/NotebooksPage";
import SyntheticMonitoringPage from "./pages/SyntheticMonitoringPage";
import UserManagementPage from "./pages/settings/UserManagementPage";
import ProjectsPage from "./pages/settings/ProjectsPage";
import IntegrationsPage from "./pages/settings/IntegrationsPage";
import SettingsPage from "./pages/settings/SettingsPage";
import AppLayout from "./components/layout/AppLayout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-xs text-muted-foreground font-mono tracking-widest uppercase">[ Initializing Control Tower ]</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/report/incidents/:incidentId" element={<IncidentReportPage />} />
      <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="hostmap" element={<HostMapPage />} />
        <Route path="pipelines" element={<PipelineRegistryPage />} />
        <Route path="pipelines/:pipelineId" element={<PipelineDetailsPage />} />
        <Route path="metrics" element={<MetricsExplorerPage />} />
        <Route path="logs" element={<LogsExplorerPage />} />
        <Route path="traces" element={<TracesExplorerPage />} />
        <Route path="incidents" element={<IncidentCenterPage />} />
        <Route path="monitors" element={<MonitorsPage />} />
        <Route path="slos" element={<SLOsPage />} />
        <Route path="dashboards" element={<DashboardsPage />} />
        <Route path="lineage" element={<LineageExplorerPage />} />
        <Route path="events" element={<EventsExplorerPage />} />
        <Route path="notebooks" element={<NotebooksPage />} />
        <Route path="synthetics" element={<SyntheticMonitoringPage />} />
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/users" element={<UserManagementPage />} />
        <Route path="settings/projects" element={<ProjectsPage />} />
        <Route path="settings/integrations" element={<IntegrationsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
